import { render } from "./HeaderFour.vue?vue&type=template&id=62000d30"
import script from "./HeaderFour.vue?vue&type=script&lang=js"
export * from "./HeaderFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__